import Model from '../Model';
import Mithril from 'mithril';

export default class IndexWindow extends Model {
  pkgId() {
    return Model.attribute<number>('pkgId').call(this);
  }
  image() {
    return Model.attribute<string>('image').call(this);
  }
  imgLink() {
    return Model.attribute<string>('imgLink').call(this);
  }

  status() {
    return Model.attribute<number>('status').call(this);
  }
}
